import localize from "../../../../common/localize";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";
import { getValueInCurrency } from "../../../../common/utils";
import { getCurrencyFromSetup } from "../../../../common/EntitiesManagement";
import {
  isSettled,
  getSettledTotal,
  SettlementReceiptLine,
} from "../../../settlement/components/settlementReceipt";

export default function ReportSettlement({ settlementDetails }) {
  const currency = getCurrencyFromSetup();

  // Only show settled details (Approved / Payed).
  const settledDetails = (settlementDetails ?? []).filter(isSettled);

  const grandTotal = getSettledTotal(settledDetails);

  // Group by personal.
  const groupsMap = new Map();
  settledDetails.forEach((item) => {
    const key = item?.personal?.id ?? item?.personal?.FullName ?? "unknown";
    if (!groupsMap.has(key)) {
      groupsMap.set(key, {
        name: item?.personal?.FullName ?? localize.no_data,
        items: [],
      });
    }
    groupsMap.get(key).items.push(item);
  });
  const groups = Array.from(groupsMap.values());

  return (
    <div>
      <ReportSectionTitle title={localize.settlement_detail_title} />
      <div className="report_section_without_top_border">
        {settledDetails.length > 0 ? (
          <div style={{ padding: "8px 12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                borderBottom: "1px solid #000",
                paddingBottom: "4px",
                marginBottom: "8px",
              }}
            >
              <span className="report_little_text">
                {localize.settlement_total_settled_value}
              </span>
              <span
                className="report_little_text"
                style={{ textAlign: "right" }}
              >
                {getValueInCurrency(currency, grandTotal)}
              </span>
            </div>

            {groups.map((group, gIndex) => {
              const personalTotal = getSettledTotal(group.items);
              return (
                <div key={gIndex} style={{ marginBottom: "10px" }}>
                  <div className="report_little_text" style={{ fontWeight: "bold" }}>
                    {group.name}
                  </div>
                  {group.items.map((item, iIndex) => (
                    <SettlementReceiptLine key={iIndex} item={item} index={iIndex} />
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderTop: "1px dashed #999",
                      marginTop: "5px",
                      paddingLeft: "12px",
                    }}
                  >
                    <span
                      className="report_little_text"
                      style={{ fontWeight: "bold" }}
                    >
                      {`${localize.settlement_total_settled_value} (${group.name})`}
                    </span>
                    <span
                      className="report_little_text"
                      style={{ fontWeight: "bold", whiteSpace: "nowrap", textAlign: "right" }}
                    >
                      {getValueInCurrency(currency, personalTotal)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <label className="report_little_text">{localize.no_data}</label>
        )}
      </div>
    </div>
  );
}
